import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Counter } from '../../models/counter';
import { faPlus, faMinus, faLock } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-up-down',
  templateUrl: 'up-down.component.html',
  styleUrls: ['up-down.component.scss']
})
export class UpDownComponent implements OnInit {
  @Input() countUpEnabled: boolean;
  @Input() countDownEnabled: boolean;
  @Input() counter: Counter;
  @Output() counterChanged: EventEmitter<any> = new EventEmitter<any>();

  @Input() isLast: boolean;

  @Input() isLocked: boolean;
  @Output() unlockRequest: EventEmitter<any> = new EventEmitter<any>();

  faPlus = faPlus;
  faMinus = faMinus;
  faLock = faLock;

  ngOnInit() {
    this.countUpEnabled = true;
    this.countDownEnabled = true;
  }

  onClickCountChangeByOne(isUp: boolean) {
    if (this.isLocked) {
      this.unlockRequest.emit();
      return;
    }

    this.countChangeByOne(isUp);
  }

  countChangeByOne(isUp: boolean) {
    if (isUp && this.counter.canCountUp || !isUp && this.counter.canCountDown) {
      this.counter.count += isUp ? 1 : -1;
      this.counterChanged.emit(this.counter);
    }
  }

  get canCountUp(): boolean {
    return this.countUpEnabled && this.counter && this.counter.canCountUp;
  }

  get canCountDown(): boolean {
    return this.countDownEnabled && this.counter && this.counter.canCountDown;
  }
}
